import { render, staticRenderFns } from "./SelectSecao.vue?vue&type=template&id=62f982d7"
import script from "./SelectSecao.vue?vue&type=script&lang=ts"
export * from "./SelectSecao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports